import intlTelInput from 'intl-tel-input';

export const input = document.querySelector("#phone");

// const button = document.querySelector("#btn");
const validMsg = document.querySelector("#check-phone-success");
const errorMsg = document.querySelector("#check-phone-error");

// here, the index maps to the error code returned from getValidationError - see readme
const errorMap = ["ensure the number is valid", "invalid country code", "incomplete number", "too long, did you type 0 at the beginning? remove the 0", "ensure the number is valid"];


// Get Selected Country Data initial value

export let SelectedPhoneCountry
export let PhoneInputValue
export let iti

// Reset phone validation error message
const resetPhoneInputValidationErrors = () => {
  input.classList.remove("error");
  errorMsg.innerHTML = "";
  errorMsg.classList.remove("flex");
  validMsg.classList.remove("flex");
  errorMsg.classList.add("hidden");
  validMsg.classList.add("hidden");
};

// typeof input is "object", but input is null if not found
// SelectedPhoneCountry above is undefined so typeof SelectedPhoneCountry is "undefined" 
// Due to type coercion, undefined == null is true but undefined === null is false
// So if input is null, then initialize to avoid errors
if (input !== null) {

  iti = intlTelInput(input, {
      // Show on top
      preferredCountries: ["us", "ca", "gb", "de", "gh", "ke", "za", "ng", "in", "il", "ps"],
      utilsScript: "/static-assets/js/utils.js"
      // Use /static-assets/ it will be resolved at runtime by fiber static server
      // utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js"
  });

  SelectedPhoneCountry = iti.getSelectedCountryData().iso2;

  // listen to the telephone input for changes
  input.addEventListener('countrychange', () => {
    SelectedPhoneCountry = iti.getSelectedCountryData().iso2;
  });

  // on keyup / change flag: reset
  input.addEventListener('focusout', ValidatePhoneInput);
  input.addEventListener('change', resetPhoneInputValidationErrors);
  input.addEventListener('keyup', resetPhoneInputValidationErrors);
 
}


// Will be called on form submit
export default function ValidatePhoneInput() {
    let isPossiblePhone = true
    resetPhoneInputValidationErrors();
    // If phone number is not empty
    PhoneInputValue = input.value.trim()
    if (PhoneInputValue) {
      if (iti.isPossibleNumber()) {
        isPossiblePhone = true
        validMsg.classList.add("flex");
        validMsg.classList.remove("hidden");
      } else {
        isPossiblePhone = false
        input.classList.add("error");
        let errorCode = iti.getValidationError();
        if ((errorCode === -99)) {
          // Many are facing challenges with outdated browsers
          // Maybe this will help
          isPossiblePhone = true
          return isPossiblePhone
          // errorCode = (errorCode === -99)? 0 : errorCode
        }
        console.log("phone validation error code", errorCode)
        errorMsg.innerHTML = errorMap[errorCode];
        errorMsg.classList.add("flex");
        errorMsg.classList.remove("hidden");

      }
    }
    return isPossiblePhone
}


// export default input


